import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './drop-menu.styles'
import Popover from 'pobble-components/dist/popover'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import Menu from './menu/menu.jsx'
import MenuItem from './menu-item/menu-item.jsx'
import IconHolder from './icon-holder/icon-holder.jsx'
import Separator from './separator/separator.jsx'

class DropMenu extends Component {
  constructor(props) {
    super(props)
    this.state = { openMenu: false }
  }
  closePopover() {
    this.setState({ openMenu: false })
    return true
  }
  renderMenu() {
    const { children } = this.props
    return children({
      closePopover: this.closePopover.bind(this),
      Menu: Menu,
      MenuItem: MenuItem,
      IconHolder: IconHolder,
      Separator: Separator
    })
  }
  render() {
    const {
      classes,
      popoverClassName,
      button,
      placement = 'bottom-end'
    } = this.props
    return (
      <Popover
        button={button}
        placement={placement}
        className={classNames(classes.popoverContainer, popoverClassName)}
        opened={this.state.openMenu}
        requestOpen={() => this.setState({ openMenu: true })}
        requestClose={() => this.setState({ openMenu: false })}>
        {this.renderMenu()}
      </Popover>
    )
  }
}

DropMenu.propTypes = {
  /** Render props pattern function that recieves ref and onClick as parameters  */
  button: PropTypes.func.isRequired,
  /** Placement of the popover (react-popper docs) */
  placement: PropTypes.string,
  /** Render props pattern function that recieves menu components as parameters */
  children: PropTypes.func,
  /** Additional className on popover window to restyle it */
  popoverClassName: PropTypes.string
}

export default injectSheet(styles)(DropMenu)
